export const siteInfo = {
  name: "17爆料网",
  slogan: "一起围观热点，把来龙去脉理清楚",
  intro:
    "17爆料网是一个简体中文网络热点资讯聚合与材料整理平台，围绕公开流传的热点事件，按事件梳理时间线、公开线索与多方说法，帮助读者在碎片化信息里看清全貌。",
  email: "contact@17baoliao.example.com",
  workingHours: "每日 09:00 - 21:00（节假日无休）",
  wechat: "baoliao17",
};